import React, { useContext } from "react";
import styles from "./Photo.module.scss";
import PathContext from "../../context/path";
const Photo = (props) => {
  const { img, desc, align, label, title, subtitle, use, link, textWidth=null } = props;
  const path = useContext(PathContext);
  let descElement = null;
  let labelElement = null;
  let wrapClass = `${styles.wrap}`;
  if (align !== undefined && styles[`wrap_${align}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${align}`]}`;
  }
  if (use !== undefined && styles[`wrap_${use}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${use}`]}`;
  }
  if (desc !== undefined) {
    descElement = <div className={styles.desc} style={{'width': textWidth}}>
      {desc}
    </div>;
  }
  let linkElement = null;
  if (link !== undefined && link.length > 0) {
    linkElement = <a href={link[1]}>{link[0]}</a>;
  }
  if (label !== undefined) {
    labelElement = <div className={styles.label}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}{linkElement}</div>
    </div>;
  }

  return (
    <>
      <div className={wrapClass}>

        {labelElement}
        <div className={styles.img}>
          <picture>
            <source media="(min-width: 1921px)" srcSet={`${path}/img/${img}@2x.webp`} />
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`} />
            <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
          </picture>
        </div>
        {descElement}
      </div>
    </>
  );

}

export default Photo;
